import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=bc8107d6&scoped=true&"
import script from "./PageHero.vue?vue&type=script&lang=js&"
export * from "./PageHero.vue?vue&type=script&lang=js&"
import style0 from "./PageHero.vue?vue&type=style&index=0&id=bc8107d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8107d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
